import './PtsTab.scss';
import { Empty, Spin } from 'antd';
import { TranslateString } from 'Utils/Common';
import { useEffect, useState } from 'react';
import PtsServices from '../../../../services/services/PtsServices';

const LtvAnalysis = (props: any) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [ptsData, setPtsData] = useState<any>();

    useEffect(() => {
        getAllData(props?.id);
    }, [props]);

    const getAllData = async (id: any) => {
        let object: any = {};
        object.customer_id = id;
        setLoading(true);
        PtsServices
            .getPtsData(object)
            .then((response: any) => {
                if (response?.status === 200) {
                    const responseData = response?.data;
                    setPtsData(responseData)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    }

    return (
        <>
            <Spin spinning={loading} >
                <div className="site-card-wrapper mt-3">
                        <div className='mt-4 cu-table-border'>
                            <table className="table table-sm table-bordered" >
                                <thead className="">
                                    <tr className="bg-white">
                                        <td colSpan={7} className='text-left cu-text-large fw-bold'>
                                            <div>{TranslateString('Notable done renovations')}</div>
                                        </td>
                                    </tr>
                                    <tr className='cu-bg-green align-top'>
                                        <th scope="col" className='text-left' style={{ width: "20%" }}>{TranslateString('renovation_type')}</th>
                                        <th scope="col" className='text-left' style={{ width: "15%" }}>{TranslateString('scope')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('description')}</th>
                                        <th scope="col" className='text-right' style={{ width: "10%" }}>{TranslateString('starting_year')}</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {ptsData?.done?.length > 0 ? ptsData?.done?.map((val: any) => {
                                        return (<tr className='text-left' key={Math.random()}>
                                            <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_maintenance}</td>
                                            <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_scope}</td>
                                            <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_desc}</td>
                                            <td className={`${val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""} text-right`}>{val?.pts_start_date}</td>
                                        </tr>)
                                    }) : <tr><td colSpan={7}><Empty description={TranslateString('Empty')} /></td></tr>}
                                </tbody>
                            </table>
                        </div>
                        <div className='mt-4 cu-table-border'>
                            <table className="table table-sm table-bordered" >
                                <thead className="">
                                    <tr className="bg-white">
                                        <td colSpan={7} className='text-left cu-text-large fw-bold'>
                                            <div>{TranslateString('ongoing_renovations')}</div>
                                        </td>
                                    </tr>
                                    <tr className='cu-bg-green align-top'>
                                        <th scope="col" className='text-left' style={{ width: "20%" }}>{TranslateString('renovation_type')}</th>
                                        <th scope="col" className='text-left' style={{ width: "15%" }}>{TranslateString('scope')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('description')}</th>
                                        <th scope="col" className='text-right' style={{ width: "10%" }}>{TranslateString('starting_year')}</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {ptsData?.ongoing?.length > 0 ? ptsData?.ongoing?.map((val: any) => {
                                        return (<tr className='text-left' key={Math.random()}>
                                            <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_maintenance}</td>
                                            <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_scope}</td>
                                            <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_desc}</td>
                                            <td className={`${val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""} text-right`}>{val?.pts_start_date}</td>
                                        </tr>)
                                    }) : <tr><td colSpan={7}><Empty description={TranslateString('Empty')} /></td></tr>}
                                </tbody>
                            </table>
                        </div>
                        <div className='mt-4 cu-table-border'>
                            <table className="table table-sm table-bordered" >
                                <thead className="">
                                    <tr className="bg-white">
                                        <td colSpan={7} className='text-left cu-text-large fw-bold'>
                                            <div>{TranslateString('Notable upcoming renovations')}</div>
                                        </td>
                                    </tr>
                                    <tr className='cu-bg-green align-top'>
                                        <th scope="col" className='text-left' style={{ width: "20%" }}>{TranslateString('renovation_type')}</th>
                                        <th scope="col" className='text-left' style={{ width: "15%" }}>{TranslateString('scope')}</th>
                                        <th scope="col" className='text-left'>{TranslateString('description')}</th>
                                        <th scope="col" className='text-right' style={{ width: "10%" }}>{TranslateString('starting_year')}</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {ptsData?.upcoming?.length > 0 ? ptsData?.upcoming?.map((val: any) => {
                                        return (<tr className='text-left' key={Math.random()}>
                                            <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_maintenance}</td>
                                            <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_scope}</td>
                                            <td className={val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""}>{val?.pts_desc}</td>
                                            <td className={`${val?.is_pts_maintenance_highlight ? "cu-table-bg-lightgreen" : ""} text-right`}>{val?.pts_start_date}</td>
                                        </tr>)
                                    }) : <tr><td colSpan={7}><Empty description={TranslateString('Empty')} /></td></tr>}
                                </tbody>
                            </table>
                        </div>
                </div>
            </Spin>
        </>
    );
};
export default LtvAnalysis;